import { render, staticRenderFns } from "./trend2.vue?vue&type=template&id=637a8f0a"
import script from "./trend2.vue?vue&type=script&lang=js"
export * from "./trend2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports